// extracted by mini-css-extract-plugin
module.exports = {"back-to-top-button":"styles_back-to-top-button__075os"};